import { render, staticRenderFns } from "./TalentLayout.vue?vue&type=template&id=3cf725e2&scoped=true&lang=pug&"
import script from "./TalentLayout.vue?vue&type=script&lang=js&"
export * from "./TalentLayout.vue?vue&type=script&lang=js&"
import style0 from "./TalentLayout.vue?vue&type=style&index=0&id=3cf725e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf725e2",
  null
  
)

export default component.exports